import React from "react";

const Load = () => {
  return (
    <div>
      <svg
        width="30"
        height="30"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 26.6667C13.0222 26.6667 10.5 25.6333 8.43334 23.5667C6.36668 21.5 5.33334 18.9778 5.33334 16C5.33334 13.0222 6.36668 10.5 8.43334 8.43333C10.5 6.36667 13.0222 5.33333 16 5.33333C17.5333 5.33333 19 5.64978 20.4 6.28267C21.8 6.91555 23 7.82133 24 9V6.66667C24 6.28889 24.128 5.97244 24.384 5.71733C24.64 5.46222 24.9565 5.33422 25.3333 5.33333C25.7102 5.33244 26.0271 5.46044 26.284 5.71733C26.5409 5.97422 26.6685 6.29067 26.6667 6.66667V13.3333C26.6667 13.7111 26.5387 14.028 26.2827 14.284C26.0267 14.54 25.7102 14.6676 25.3333 14.6667H18.6667C18.2889 14.6667 17.9725 14.5387 17.7173 14.2827C17.4622 14.0267 17.3342 13.7102 17.3333 13.3333C17.3325 12.9564 17.4605 12.64 17.7173 12.384C17.9742 12.128 18.2907 12 18.6667 12H22.9333C22.2222 10.7556 21.2502 9.77778 20.0173 9.06667C18.7845 8.35556 17.4453 8 16 8C13.7778 8 11.8889 8.77778 10.3333 10.3333C8.77779 11.8889 8.00001 13.7778 8.00001 16C8.00001 18.2222 8.77779 20.1111 10.3333 21.6667C11.8889 23.2222 13.7778 24 16 24C17.5111 24 18.8947 23.6169 20.1507 22.8507C21.4067 22.0844 22.3787 21.0564 23.0667 19.7667C23.2445 19.4556 23.4947 19.2391 23.8173 19.1173C24.14 18.9956 24.4676 18.9898 24.8 19.1C25.1556 19.2111 25.4111 19.4444 25.5667 19.8C25.7222 20.1556 25.7111 20.4889 25.5333 20.8C24.6222 22.5778 23.3222 24 21.6333 25.0667C19.9445 26.1333 18.0667 26.6667 16 26.6667Z"
          fill="#4E4E4E"
        />
      </svg>
    </div>
  );
};

export default Load;
